/* */ 
(function(process) {
  "use strict";
  var get = require('lodash.get');
  var Errors = require('./Errors');
  var Utils = require('./Utils');
  function Report(parentOrOptions, reportOptions) {
    this.parentReport = parentOrOptions instanceof Report ? parentOrOptions : undefined;
    this.options = parentOrOptions instanceof Report ? parentOrOptions.options : parentOrOptions || {};
    this.reportOptions = reportOptions || {};
    this.errors = [];
    this.path = [];
    this.asyncTasks = [];
  }
  Report.prototype.isValid = function() {
    if (this.asyncTasks.length > 0) {
      throw new Error("Async tasks pending, can't answer isValid");
    }
    return this.errors.length === 0;
  };
  Report.prototype.addAsyncTask = function(fn, args, asyncTaskResultProcessFn) {
    this.asyncTasks.push([fn, args, asyncTaskResultProcessFn]);
  };
  Report.prototype.processAsyncTasks = function(timeout, callback) {
    var validationTimeout = timeout || 2000,
        tasksCount = this.asyncTasks.length,
        idx = tasksCount,
        timedOut = false,
        self = this;
    function finish() {
      process.nextTick(function() {
        var valid = self.errors.length === 0,
            err = valid ? undefined : self.errors;
        callback(err, valid);
      });
    }
    function respond(asyncTaskResultProcessFn) {
      return function(asyncTaskResult) {
        if (timedOut) {
          return;
        }
        asyncTaskResultProcessFn(asyncTaskResult);
        if (--tasksCount === 0) {
          finish();
        }
      };
    }
    if (tasksCount === 0 || this.errors.length > 0) {
      finish();
      return;
    }
    while (idx--) {
      var task = this.asyncTasks[idx];
      task[0].apply(null, task[1].concat(respond(task[2])));
    }
    setTimeout(function() {
      if (tasksCount > 0) {
        timedOut = true;
        self.addError("ASYNC_TIMEOUT", [tasksCount, validationTimeout]);
        callback(self.errors, false);
      }
    }, validationTimeout);
  };
  Report.prototype.getPath = function(returnPathAsString) {
    var path = [];
    if (this.parentReport) {
      path = path.concat(this.parentReport.path);
    }
    path = path.concat(this.path);
    if (returnPathAsString !== true) {
      path = "#/" + path.map(function(segment) {
        if (Utils.isAbsoluteUri(segment)) {
          return "uri(" + segment + ")";
        }
        return segment.replace(/\~/g, "~0").replace(/\//g, "~1");
      }).join("/");
    }
    return path;
  };
  Report.prototype.getSchemaId = function() {
    if (!this.rootSchema) {
      return null;
    }
    var path = [];
    if (this.parentReport) {
      path = path.concat(this.parentReport.path);
    }
    path = path.concat(this.path);
    while (path.length > 0) {
      var obj = get(this.rootSchema, path);
      if (obj && obj.id) {
        return obj.id;
      }
      path.pop();
    }
    return this.rootSchema.id;
  };
  Report.prototype.hasError = function(errorCode, params) {
    var idx = this.errors.length;
    while (idx--) {
      if (this.errors[idx].code === errorCode) {
        var match = true;
        var idx2 = this.errors[idx].params.length;
        while (idx2--) {
          if (this.errors[idx].params[idx2] !== params[idx2]) {
            match = false;
          }
        }
        if (match) {
          return match;
        }
      }
    }
    return false;
  };
  Report.prototype.addError = function(errorCode, params, subReports, schemaDescription) {
    if (!errorCode) {
      throw new Error("No errorCode passed into addError()");
    }
    this.addCustomError(errorCode, Errors[errorCode], params, subReports, schemaDescription);
  };
  Report.prototype.addCustomError = function(errorCode, errorMessage, params, subReports, schemaDescription) {
    if (this.errors.length >= this.reportOptions.maxErrors) {
      return;
    }
    if (!errorMessage) {
      throw new Error("No errorMessage known for code " + errorCode);
    }
    params = params || [];
    var idx = params.length;
    while (idx--) {
      var whatIs = Utils.whatIs(params[idx]);
      var param = (whatIs === "object" || whatIs === "null") ? JSON.stringify(params[idx]) : params[idx];
      errorMessage = errorMessage.replace("{" + idx + "}", param);
    }
    var err = {
      code: errorCode,
      params: params,
      message: errorMessage,
      path: this.getPath(this.options.reportPathAsArray),
      schemaId: this.getSchemaId()
    };
    if (schemaDescription) {
      err.description = schemaDescription;
    }
    if (subReports != null) {
      if (!Array.isArray(subReports)) {
        subReports = [subReports];
      }
      err.inner = [];
      idx = subReports.length;
      while (idx--) {
        var subReport = subReports[idx],
            idx2 = subReport.errors.length;
        while (idx2--) {
          err.inner.push(subReport.errors[idx2]);
        }
      }
      if (err.inner.length === 0) {
        err.inner = undefined;
      }
    }
    this.errors.push(err);
  };
  module.exports = Report;
})(require('process'));
